function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { I18nConsumer } from '@wegic/i18n-core';
import { IconLock } from '@wegic/icon';
import { Button, Divider, Form, Input } from '@wegic/ui';
import { useCallback, useState } from 'react';
import IconEmail from '@/assets/icons/Email.svg?react';
import IconGoogle from '@/assets/icons/Google.svg?react';
import { FORM_RULES, USER_PRIVACY_POLICY_URL, USER_TERMS_URL } from '@/const/form';
import { useEmailLogin } from '@/hooks/useAuth';
import { useGoogleAuth } from '@/hooks/useGoogleAuth';
import { useInviteCodeMessage } from '@/hooks/useInviteCodeMessage';
import { useGoogleLogin } from '@/integrations/google-identity';
import { LOGIN_I18N_NAMESPACE, loginI18nLoaders } from '../../i18n/loaders';
import { emitLoginClick } from './helper';
import styles from './index.module.less';
var FormItem = Form.Item;
function LoginFormContent(props) {
    var config = props.config, onForgetPassword = props.onForgetPassword, onRegister = props.onRegister;
    var _ref = config || {}, api = _ref.api, ui = _ref.ui, onEvent = _ref.onEvent, initialEmail = _ref.initialEmail;
    var header = ui === null || ui === void 0 ? void 0 : ui.header;
    var _Form_useForm = _sliced_to_array(Form.useForm(), 1), form = _Form_useForm[0];
    var _useState = _sliced_to_array(useState(true), 2), submitDisabled = _useState[0], setSubmitDisabled = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), visibility = _useState1[0], setVisibility = _useState1[1];
    var _useEmailLogin = useEmailLogin({
        apiConfig: api,
        getAnonymousId: config === null || config === void 0 ? void 0 : config.getAnonymousId,
        onEvent: onEvent
    }), login = _useEmailLogin.login, emailLoginLoading = _useEmailLogin.loading;
    var handleGoogleLogin = useGoogleAuth({
        apiConfig: api,
        getAnonymousId: config === null || config === void 0 ? void 0 : config.getAnonymousId,
        onEvent: onEvent
    }).handleGoogleLogin;
    var googleLoginFn = useGoogleLogin({
        flow: 'auth-code',
        ux_mode: 'popup',
        state: 'google',
        client_id: api === null || api === void 0 ? void 0 : api.googleClientId,
        onSuccess: function(codeResponse) {
            handleGoogleLogin(codeResponse);
        }
    });
    var handleGoogleLoginClick = useCallback(function() {
        void emitLoginClick(onEvent, 'google');
        googleLoginFn();
    }, [
        googleLoginFn,
        onEvent
    ]);
    var handleValuesChange = useCallback(function(_, values) {
        var _ref;
        var _values_password;
        setSubmitDisabled(!values.email || !values.password || ((_ref = (_values_password = values.password) === null || _values_password === void 0 ? void 0 : _values_password.length) !== null && _ref !== void 0 ? _ref : 0) < 6);
    }, []);
    var handleLoginSubmit = useCallback(function() {
        return _async_to_generator(function() {
            var formData, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                            type: 'privacy:hide'
                        });
                        return [
                            4,
                            form.validate().catch(function() {
                                return null;
                            })
                        ];
                    case 1:
                        formData = _state.sent();
                        if (!formData) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            login(formData.email, formData.password)
                        ];
                    case 2:
                        result = _state.sent();
                        if (result.needRegister) {
                            // 需要注册，跳转到注册页面
                            sessionStorage.setItem('register', JSON.stringify(result.formData));
                            onRegister === null || onRegister === void 0 ? void 0 : onRegister();
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        form,
        login,
        onRegister,
        onEvent
    ]);
    var handleEmailLoginClick = useCallback(function() {
        void emitLoginClick(onEvent, 'email');
        void handleLoginSubmit();
    }, [
        handleLoginSubmit,
        onEvent
    ]);
    var handlePasswordFocus = useCallback(function() {
        setTimeout(function() {
            if (!visibility) {
                onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                    type: 'privacy:show'
                });
            }
        }, 0);
    }, [
        visibility,
        onEvent
    ]);
    var handlePasswordBlur = useCallback(function() {
        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
            type: 'privacy:hide'
        });
    }, [
        onEvent
    ]);
    var handleVisibilityChange = useCallback(function(v) {
        setVisibility(v);
        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
            type: v ? 'privacy:hide' : 'privacy:show'
        });
    }, [
        onEvent
    ]);
    var handleForgetPasswordClick = useCallback(function() {
        onForgetPassword === null || onForgetPassword === void 0 ? void 0 : onForgetPassword();
    }, [
        onForgetPassword
    ]);
    var handlePolicyClick = useCallback(function(url) {
        window.open(url, '_blank');
    }, []);
    useInviteCodeMessage();
    return /*#__PURE__*/ _jsxs("div", {
        className: styles['login-form'],
        children: [
            (header === null || header === void 0 ? void 0 : header.title) && /*#__PURE__*/ _jsxs("div", {
                className: styles.heading,
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: styles.title,
                        children: header.title
                    }),
                    header.subtitle && /*#__PURE__*/ _jsx("p", {
                        className: styles.subtitle,
                        children: header.subtitle
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Button, {
                    block: true,
                    size: "xlarge",
                    onClick: handleGoogleLoginClick,
                    status: "plain",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles['google-button'],
                        children: [
                            /*#__PURE__*/ _jsx(IconGoogle, {
                                className: styles['google-icon']
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                style: {
                                    flex: 1
                                },
                                children: intl.get('Login_Form_GoogleButton')
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Divider, {
                className: styles.divider,
                children: intl.get('Login_Form_Or')
            }),
            /*#__PURE__*/ _jsxs(Form, {
                autoComplete: "off",
                layout: "vertical",
                form: form,
                initialValues: initialEmail ? {
                    email: initialEmail
                } : undefined,
                onValuesChange: handleValuesChange,
                validateTrigger: [],
                children: [
                    /*#__PURE__*/ _jsx(FormItem, {
                        field: "email",
                        rules: FORM_RULES.email,
                        children: /*#__PURE__*/ _jsx(Input, {
                            variant: "white",
                            placeholder: intl.get('Login_Form_EmailPlaceholder'),
                            prefix: /*#__PURE__*/ _jsx(IconEmail, {}),
                            autoFocus: true
                        })
                    }),
                    /*#__PURE__*/ _jsx(FormItem, {
                        field: "password",
                        rules: FORM_RULES.password,
                        children: /*#__PURE__*/ _jsx(Input.Password, {
                            variant: "white",
                            onKeyDown: function(e) {
                                if (e.key === 'Enter') {
                                    handleLoginSubmit();
                                }
                            },
                            onFocus: handlePasswordFocus,
                            onBlur: handlePasswordBlur,
                            onVisibilityChange: handleVisibilityChange,
                            placeholder: intl.get('Login_Form_PasswordPlaceholder'),
                            prefix: /*#__PURE__*/ _jsx(IconLock, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'end'
                },
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "secondary",
                    className: styles['forget-password'],
                    onClick: handleForgetPasswordClick,
                    children: intl.get('Login_Form_ForgetPassword')
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                block: true,
                onClick: handleEmailLoginClick,
                loading: emailLoginLoading,
                disabled: submitDisabled,
                className: styles['submit-button'],
                children: /*#__PURE__*/ _jsx("span", {
                    children: intl.get('Login_Form_ButtonText')
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.policy,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: intl.get('Login_Form_Policy')
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.link,
                        onClick: function() {
                            return handlePolicyClick(USER_TERMS_URL);
                        },
                        children: intl.get('Login_Form_PolicyTerms')
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: ', '
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.link,
                        onClick: function() {
                            return handlePolicyClick(USER_PRIVACY_POLICY_URL);
                        },
                        children: intl.get('Login_Form_PolicyPrivacy')
                    })
                ]
            })
        ]
    });
}
function LoginForm(props) {
    return /*#__PURE__*/ _jsx(I18nConsumer, {
        loaders: loginI18nLoaders,
        namespace: LOGIN_I18N_NAMESPACE,
        children: /*#__PURE__*/ _jsx(LoginFormContent, _object_spread({}, props))
    });
}
export default LoginForm;
